var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormsPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 108,
    viewBox: "0 0 302 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107.707,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "#F7F7F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.707,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "#CECEDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M127.207 39C126.332 39 125.613 39.2812 125.051 39.8438C124.488 40.4062 124.207 41.125 124.207 42V66C124.207 66.875 124.488 67.5938 125.051 68.1562C125.613 68.7188 126.332 69 127.207 69H175.207C176.082 69 176.801 68.7188 177.363 68.1562C177.926 67.5938 178.207 66.875 178.207 66V42C178.207 41.125 177.926 40.4062 177.363 39.8438C176.801 39.2812 176.082 39 175.207 39H127.207ZM121.207 42C121.27 40.3125 121.863 38.9062 122.988 37.7812C124.113 36.6562 125.52 36.0625 127.207 36H175.207C176.895 36.0625 178.301 36.6562 179.426 37.7812C180.551 38.9062 181.145 40.3125 181.207 42V66C181.145 67.6875 180.551 69.0938 179.426 70.2188C178.301 71.3438 176.895 71.9375 175.207 72H127.207C125.52 71.9375 124.113 71.3438 122.988 70.2188C121.863 69.0938 121.27 67.6875 121.207 66V42ZM133.207 46.5V61.5C133.145 62.4375 132.645 62.9375 131.707 63C130.77 62.9375 130.27 62.4375 130.207 61.5V46.5C130.27 45.5625 130.77 45.0625 131.707 45C132.645 45.0625 133.145 45.5625 133.207 46.5Z",
    fill: "#706B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsPlaceholder);
export default __webpack_public_path__ + "static/media/forms-placeholder.23d5c6cc1577c382719c491e69cf36d9.svg";
export { ForwardRef as ReactComponent };